function t(r = 10) {
  return {
    data() {
      return {
        displayPriority: 0
      };
    },
    mounted() {
      this.runDisplayPriority();
    },
    methods: {
      runDisplayPriority() {
        const i = () => {
          requestAnimationFrame(() => {
            this.displayPriority++, this.displayPriority < r && i();
          });
        };
        i();
      },
      defer(i) {
        return this.displayPriority >= i;
      }
    }
  };
}
export {
  t as default
};
//# sourceMappingURL=defer.js.map
